export const sortingByHotClicks = (games) => {
    return games
        .sort(
            (a, b) =>
                Number(b.go_hot) - Number(a.go_hot) ||
                parseFloat(b.clicks || 0) - parseFloat(a.clicks || 0) ||
                a.name.localeCompare(b.name)
        )
        .sort(
            (a, b) =>
                b.go_hot && a.go_hot
                    ? parseInt(a.go_priority) - parseInt(b.go_priority)
                    : 0
        )
}
